var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"elevation":"3"}},[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v(" Curvas de temperatura y frecuencia cardíaca de "+_vm._s(_vm.estaFecha)+" ")])],1),_c('apexchart',{attrs:{"height":"300px","type":"line","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }